import { HOME_PATHS } from '~constants/routes';

export const isActualPathHome = () => HOME_PATHS.includes(window.location.pathname);
